import { render, staticRenderFns } from "./ModalTransPay.vue?vue&type=template&id=43e736e3&"
import script from "./ModalTransPay.vue?vue&type=script&lang=js&"
export * from "./ModalTransPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports